import http from './axios'

// 退出登录
const loginOut = () => {
    return http.json_post('/manager/user/logout')
}

// 获取用户信息
const getInfo = () => {
    return http.get('/manager/user/getLoginManagerInfo')
}

export default {
    getInfo,
    loginOut
}